import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/deliveryBusiness',
  meta,
  component: layoutHeaderAside,
  children: [
    // {
    //   path: '/deliveryBusiness/appointPickupGoods',
    //   name: 'appointPickupGoods',
    //   component: () => import('@/pages/deliveryBusiness/appointPickupGoods.vue'),
    //   meta: {
    //     ...meta,
    //     title: '预约领货',
    //     requireAuth: true
    //   }
    // },
    {
      path: '/deliveryBusiness/pickupGoodsRecords',
      name: 'pickupGoodsRecords',
      component: () => import('@/pages/deliveryBusiness/pickupGoodsRecords.vue'),
      meta: {
        ...meta,
        title: '预约领货-预约记录',
        // requireAuth: true
      }
    },
    // {
    //   path: '/deliveryBusiness/appointReturnContainer',
    //   name: 'appointReturnContainer',
    //   component: () => import('@/pages/deliveryBusiness/appointReturnContainer.vue'),
    //   meta: {
    //     ...meta,
    //     title: '预约还箱',
    //     requireAuth: true
    //   }
    // },
    {
      path: '/deliveryBusiness/returnContainerRecords',
      name: 'returnContainerRecords',
      component: () => import('@/pages/deliveryBusiness/returnContainerRecords.vue'),
      meta: {
        ...meta,
        title: '预约还箱-预约记录',
        // requireAuth: true
      }
    },
    {
          path: '/deliveryBusiness/zwhx',
          name: 'zwhx',
          component: () => import('@/pages/jzxyz/zwhx/index.vue'),
              meta: {
              ...meta,
              title: '站外换箱',
          requireAuth: true
      },
    },
    {
      path: '/deliveryBusiness/lxtz',
      name: 'lxtz',
      component: () => import('@/pages/deliveryBusiness/pickupGoodsNotice.vue'),
          meta: {
          ...meta,
          title: '领箱通知',
          requireAuth: true
      },
    },
    {
      path: '/deliveryBusiness/jzyy',
      name: 'jzyy',
      component: () => import('@/pages/deliveryBusiness/inboundReservation.vue'),
          meta: {
          ...meta,
          title: '进站预约',
          requireAuth: true
      },
    },
  ]
}
